import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postSales({ body }) {
  return BaseService.post(REST.SALES, body);
}

function putSales({ body, id }) {
  return BaseService.put(REST.SALES_ID(id), body);
}

function getSales(params) {
  return BaseService.get(REST.SALES, {
    params: paramsFilter({ params }),
  });
}

function getHotSales() {
  return BaseService.get(REST.HOT_SALES);
}

function deleteSales({ id }) {
  return BaseService.delete(REST.SALES_ID(id));
}

export default {
  postSales,
  putSales,
  getSales,
  deleteSales,
  getHotSales,
};
